import moment from "moment";
import { IntAssessLog } from "@/model/IntAssessLog";
export class IntAssessHdr {
  CandID;
  JobAdCode;
  Seq;
  DateInt;
  Interviewer;
  Rem;
  JobCode;
  DateCommence;
  BasicSalary;
  SalPayCycle;
  Allw;
  PayCycle;
  IntStatus;
  DateOffer;
  OfferBy;
  IntAssessDtlList;
  JobName;
  IntAssessLogModel;
  DateContSign;
  ContSignBy;
  DateRefChk;
  RefChkBy;
  DateDataEntry;
  DataEntryBy;
  DateVerified;
  VerifiedBy;
  IsFinalApprover;
  RejLog;
  IsHrAdminGroup;
  IsDateCommMenuActive;
  IsDateContMenuActive;
  IsDateRefMenuActive;
  IsDateDataMenuActive;
  IsDateVerMenuActive;
  tempCode;
  IsEditMode;
  AnotherInterviewSch;
  AnotherInterviewer;
  UserName;
  IsAnotherInterview;
  AnotherInterviewerName;
  constructor() {
    this.CandID = "";
    this.JobAdCode = "";
    this.Seq = "";
    this.DateInt = moment().format("YYYY-MM-DD");
    this.Interviewer = "";
    this.Rem = "";
    this.JobCode = "";
    this.DateCommence = moment().format("YYYY-MM-DD");
    this.BasicSalary = "";
    this.SalPayCycle = "";
    this.Allw = "";
    this.PayCycle = "";
    this.IntStatus = "";
    this.DateOffer = moment().format("YYYY-MM-DD");
    this.OfferBy = "";
    this.JobName = "";
    this.IntAssessDtlList = [];
    this.IntAssessLogModel = new IntAssessLog();
    this.DateContSign = moment().format("YYYY-MM-DD");
    this.ContSignBy = "";
    this.DateRefChk = moment().format("YYYY-MM-DD");
    this.RefChkBy = "";
    this.DateDataEntry = moment().format("YYYY-MM-DD");
    this.DataEntryBy = "";
    this.DateVerified = moment().format("YYYY-MM-DD");
    this.VerifiedBy = "";
    this.IsFinalApprover = false;
    this.RejLog = "";
    this.IsHrAdminGroup = false;
    this.IsDateCommMenuActive = false;
    this.IsDateContMenuActive = false;
    this.IsDateRefMenuActive = false;
    this.IsDateDataMenuActive = false;
    this.IsDateVerMenuActive = false;
    this.tempCode = "";
    this.IsEditMode = false;
    this.AnotherInterviewSch = moment().format("YYYY-MM-DD");
    this.AnotherInterviewer = "";
    this.UserName = "";
    this.IsAnotherInterview = false;
    this.AnotherInterviewerName = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/IntAssessHdr.js